import React, { SVGProps } from "react";

export default function SupSearch(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6345 13.2C11.5063 14.1958 10.0242 14.8001 8.40102 14.8001C4.86637 14.8001 2.00098 11.9347 2.00098 8.40004C2.00098 4.8654 4.86637 2 8.40102 2C11.9357 2 14.8011 4.8654 14.8011 8.40004C14.8011 10.0228 14.1971 11.5046 13.2017 12.6327L17.9989 17.4146L17.4529 18L12.6345 13.2ZM14.0011 8.40004C14.0011 11.4929 11.4938 14.0001 8.40102 14.0001C5.3082 14.0001 2.80098 11.4929 2.80098 8.40004C2.80098 5.30723 5.3082 2.80001 8.40102 2.80001C11.4938 2.80001 14.0011 5.30723 14.0011 8.40004Z"
        fill="currentColor"
      />
    </svg>
  );
}
